/**
 * Copy for the listing-agnostic chrome of a stepped booking sheet (header
 * Back button, "Step n of N" line, completed-step chip accessible names and
 * the footer's Next CTA). Shared by every listing kind that steps through
 * `SteppedSheet` — services and stays today; packages reuse it without a
 * second copy of these strings.
 */

// Sheet chrome accessible names.
export const SHEET_BACK_ARIA_LABEL = 'Back';

/** Header subtitle, e.g. "Step 1 of 2". */
export const stepOfTotalLabel = (stepNumber: number, totalSteps: number): string =>
  `Step ${stepNumber} of ${totalSteps}`;

/** Accessible name for a completed-step chip, e.g. "Change date: Sat, Oct
 *  3". */
export const changeStepChipLabel = (stepTitle: string, summary: string): string =>
  `Change ${stepTitle.toLowerCase()}: ${summary}`;

export const NEXT_CTA_LABEL = 'Next';

// An Option step's blocked-"Next" label — shared by services and stays.
export const CHOOSE_AN_OPTION_LABEL = 'Choose an option';

// An Extras step's blocked-CTA label and its required-groups helper line —
// shared by services and stays.
export const CHOOSE_REQUIRED_EXTRAS_LABEL = 'Choose required extras';
/** Required-extras helper line under the Extras list, shown while a
 *  required modifier group is still unsatisfied. */
export const REQUIRED_EXTRAS_HELPER_TEXT = 'Select the required options above to continue.';

/** "N guest(s)" — a Guests step/chip's units line. Shared by services and
 *  stays. */
export const guestsUnitsLine = (guestCount: number): string =>
  `${guestCount} guest${guestCount !== 1 ? 's' : ''}`;

// Step titles shared by every listing kind that mounts an Option and/or
// Guests step through `SteppedSheet` — services and stays today.
export const OPTION_STEP_TITLE = 'Option';
export const GUESTS_STEP_TITLE = 'Guests';
export const EXTRAS_HEADING = 'Extras';
